import React from 'react';

import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

// Fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

export default function PaginationComponent({ currentPage, totalPages, onPageChange }) {

    // 페이지 번호를 표시할 배열을 생성합니다.
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }

  return (
    <Pagination listClassName="justify-content-center">
      <PaginationItem disabled={currentPage === 1}>
          <PaginationLink
            onClick={() => onPageChange(currentPage - 1)} href="#">
              <FontAwesomeIcon icon={faAngleLeft} />
          </PaginationLink>
      </PaginationItem>

      {pageNumbers.map((pageNumber) => (
        <PaginationItem key={pageNumber} active={pageNumber === currentPage}>
          <PaginationLink
            onClick={() => onPageChange(pageNumber)}
            href="#">
            {pageNumber}
          </PaginationLink>
        </PaginationItem>
      ))}

      <PaginationItem disabled={currentPage === totalPages}>
          <PaginationLink
            onClick={() => onPageChange(currentPage + 1)} href="#">
            <FontAwesomeIcon icon={faAngleRight} />
          </PaginationLink>
      </PaginationItem>
    </Pagination>
  );
}